import { createSelector } from "@reduxjs/toolkit";

const getListPartnerTracking = (state) => state.listPartnerTracking;

const getIsGetPartnerTracking = (state) => state.isGetPartnerTracking;

const getIsCreatePartnerTracking = (state) => state.isCreatePartnerTracking;

const getIsRemovePartnerTracking = (state) => state.isRemovePartnerTracking;

const getTotal = (state) => state.total;

export const partnerTrackingSelector = createSelector(
  [
    getListPartnerTracking,
    getIsGetPartnerTracking,
    getIsCreatePartnerTracking,
    getIsRemovePartnerTracking,
    getTotal,
  ],
  (
    listPartnerTracking,
    isGetPartnerTracking,
    isCreatePartnerTracking,
    isRemovePartnerTracking,
    total
  ) => ({
    listPartnerTracking,
    isGetPartnerTracking,
    isCreatePartnerTracking,
    isRemovePartnerTracking,
    total,
  })
);
